import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useIDAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const id = ref({})
  const isSubmitting = ref(false)
  const collection = 'id'

  const create = async (data) => {
    if (!hasPermission('organization-ids', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        client_id: oid(userData.client.$oid),
        name: data.name.value,
        history: [createInitialAuditEntry()],
      }

      await createItem({ collection, payload })

      showSuccessMessage(i18n.t('message.id_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.id_add_error'))
    } finally {
      router.push({ name: 'organization-id-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    id,
    isSubmitting,
  }
}
